import { varchar, jsonb, boolean, timestamp, numeric, date, json, text, integer } from 'drizzle-orm/pg-core/columns';
import { pgTable } from 'drizzle-orm/pg-core/table';
import { uniqueIndex } from 'drizzle-orm/pg-core/indexes';
import { commonFields } from './common-fields';
import { relations } from 'drizzle-orm/relations';
import { InferSelectModel } from 'drizzle-orm/table';
import { companyInviteRequests } from './company-invite-requests';
import { companyUsers } from './company-users';
import { companyTemplates } from './agreements';

export type Company = InferSelectModel<typeof companies>;

export const companies = pgTable(
  'companies',
  {
    ...commonFields,
    bolagsverketsid: varchar(),
    organizationNumber: varchar().notNull(),
    name: varchar().notNull(),
    address: json(),
    county: varchar(),
    municipal: varchar(),
    mail: varchar(),
    foundationDate: date(),
    meetingSequential: varchar(),
    authorizedSignatory: text(),
    provisions: json(),
    currency: varchar(),
    shareCapital: numeric(),
    shareCapitalMax: numeric(),
    shareCapitalMin: numeric(),
    sharesTotal: numeric(),
    sharesMax: numeric(),
    sharesMin: numeric(),
    badShareCapitalData: boolean(),
    originShareClassName: varchar(),
    email: varchar(),
    web: varchar(),
    useGravatar: boolean().default(false).notNull(),
    directive: varchar(),
    directiveApprovedCode: varchar(),
    directiveApprover: varchar(),
    fiscalYear: varchar(),
    reservationArbitrator: boolean(),
    reservationConsent: boolean(),
    reservationDescrepancy: boolean(),
    reservationMajority: boolean(),
    reservationOther: varchar(),
    reservationRightOfFirstRefusal: boolean(),
    reservationPreferential: boolean(),
    reservationReconciliation: boolean(),
    reservationReconciliationDate: date(),
    reservationPostTransferPurchaseRight: boolean(),
    reservationVote: boolean(),
    residenceCounty: varchar(),
    residenceMunicipal: varchar(),
    shareholderMeetingBeforeMonth: varchar(),
    shareholderMeetingHowtoCall: varchar(),
    shareholderMeetingMonth: varchar(),
    boardSettings: jsonb(),
    shareClasses: jsonb().default([]).notNull(),
    sharesAtFoundation: numeric(),
    isPublic: boolean().default(false).notNull(),
    promoCode: varchar(),
    boardMembersMin: varchar(),
    boardMembersMax: varchar(),
    boardSubstitutesMin: varchar(),
    boardSubstitutesMax: varchar(),
    reservationNoAuditor: boolean(),
    stripeCustomerId: varchar(),
    isAntlerCompany: boolean().default(false).notNull(),
    stripeInvitePromoCode: varchar(),
    hubspotObjectId: varchar(),
    allowShortQeso: boolean().notNull(),
    capTableTrialExpires: timestamp(),
    shareRegisterLimit: integer(),
  },
  table => {
    return [
      {
        idxCStripeCusId: uniqueIndex('idx_c_stripe_cus_id').using('btree', table.stripeCustomerId.asc().nullsLast()),
        indexCompaniesOnOrganizationNumber: uniqueIndex('index_companies_on_organization_number').using(
          'btree',
          table.organizationNumber.asc().nullsLast(),
        ),
      },
    ];
  },
);

export const companiesRelations = relations(companies, ({ many }) => ({
  // companySubscriptions: many(companySubscriptions),
  // companyDirectors: many(companyDirectors),
  // capTables: many(capTables),
  // companyInvites: many(companyInvites),
  companyUsers: many(companyUsers),
  companyInviteRequests: many(companyInviteRequests),
  companyTemplates: many(companyTemplates),
  // articlesOfAssocs: many(articlesOfAssocs),
  // cooptedMeetingParticipants: many(cooptedMeetingParticipants),
  // issuancePrograms: many(issuancePrograms),
  // identities: many(identities),
  // meetingAgendaTemplates: many(meetingAgendaTemplates),
  // meetings: many(meetings),
  // shareSubscriptions: many(shareSubscriptions),
  // shareholders_companyId: many(shareholders, {
  //   relationName: 'shareholders_companyId_companies_id',
  // }),
  // shareholders_ownerCompanyId: many(shareholders, {
  //   relationName: 'shareholders_ownerCompanyId_companies_id',
  // }),
  // snrAuthorizations: many(snrAuthorizations),
  // snrBonds: many(snrBonds),
  // shareIssues: many(shareIssues),
  // shareTransactionGroups: many(shareTransactionGroups),
  // snrShareCapitalChanges: many(snrShareCapitalChanges),
  // warrantPrograms: many(warrantPrograms),
  // snrCases: many(snrCases),
  // authorizationGroups: many(authorizationGroups),
  // files: many(files),
  // documentTemplates: many(documentTemplate),
}));
